/**
 * Details about a group that the user belongs to
 */
export class UserGroup {
  public id: number;
  public name: string;
  public program_title: string;
  public progress: number;
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/models/program/user-group.ts